import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../redux/actions/subCategoryAction.js';
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { RedirectPageData } from "../../../utils/static-data/index.js";
import { api_urls } from "../../../utils/api-urls/index.js";

const AddSubCategory = ({ mode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData = location?.state?.stateData;

  const { categoryData } = useSelector(state => state.categoryReducer)
  const [subCategoryDetail, setSubCategoryDetail] = useState({ redirectPage: stateData ? stateData?.redirect_page : '', categoryId: stateData ? stateData?.categoryId?.category_name : '', subCategoryName: stateData ? stateData?.sub_category_name : '', status: stateData ? stateData?.status : '' });
  const [inputFieldError, setInputFieldError] = useState({ redirectPage: '', categoryId: '', subCategoryName: '', subCategoryImage: '', status: '' });
  const [subCategoryImage, setSubCategoryImage] = useState({ file: stateData ? api_urls + stateData?.image : logo_icon, bytes: "" });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setSubCategoryDetail({ ...subCategoryDetail, [name]: value });
  };

  //* Handle Sub Category Image
  const handleSubCategoryImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0]?.size < 1 * 1024 * 1024) {
        setSubCategoryImage({
          file: URL.createObjectURL(e.target.files[0]),
          bytes: e.target.files[0],
        });
      } else {
        alert("Please upload image having size less than 1 MB")
      }
    }
    handleInputFieldError("subCategoryImage", null)
  };

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { redirectPage, subCategoryName, status, categoryId } = subCategoryDetail;
    const { file } = subCategoryImage;

    if (!redirectPage) {
      handleInputFieldError("redirectPage", "Please Select Redirect Page")
      isValid = false;
    }
    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryName) {
      handleInputFieldError("subCategoryName", "Please Enter Sub Category Name")
      isValid = false;
    }
    if (redirectPage != "Yatra") {
      if (!file) {
        handleInputFieldError("subCategoryImage", "Please Select Image")
        isValid = false;
      }
    }
    return isValid;
  };

  //! Handle Submit - Creating Sub Category
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Sub Category Data :: ", { ...subCategoryDetail, subCategoryImage })
      const { categoryId, redirectPage, subCategoryName, status } = subCategoryDetail;

      if (stateData) {
        let formData = new FormData()
        formData.append("subCategoryId", stateData?._id);
        formData.append("categoryId", categoryId);
        formData.append("redirect_page", redirectPage);
        formData.append("sub_category_name", subCategoryName)
        formData.append("image", subCategoryImage?.bytes);
        formData.append("status", status);

        const payload = {
          data: formData,
          onComplete: () => navigate("/sub-category")
        };

        //! Dispatching API for Updating Category
        dispatch(SubCategoryActions.updateSubCategory(payload));

      } else {
        let formData = new FormData();
        formData.append("categoryId", categoryId);
        formData.append("redirect_page", redirectPage);
        formData.append("sub_category_name", subCategoryName);
        formData.append("image", subCategoryImage?.bytes);

        const payload = {
          data: formData,
          onComplete: () => navigate("/sub-category")
        };

        //! Dispatching API for Creating Banner
        dispatch(SubCategoryActions.createSubCategory(payload));
      }
    }
  };

  //* Redirect Category Data For Category Name Option
  const redirectCategoryData = categoryData?.filter(value => value?.redirect_page === subCategoryDetail?.redirectPage);

  useEffect(() => {
    setSubCategoryDetail({ ...subCategoryDetail, categoryId: stateData ? stateData?.categoryId?._id : '' });
  }, [subCategoryDetail.redirectPage]);

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  return (

    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Sub Category</div>
          <div onClick={() => navigate("/sub-category")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Redirect Page</InputLabel>
              <Select
                label="Select Status" variant="outlined" fullWidth
                name='redirectPage'
                value={subCategoryDetail?.redirectPage}
                onChange={handleInputField}
                error={inputFieldError.redirectPage ? true : false}
                onFocus={() => handleInputFieldError("redirectPage", null)}
              >
                <MenuItem disabled>---Select Redirect Page---</MenuItem>
                {RedirectPageData.map((value, index) => (<MenuItem key={index} value={value}>{value}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.redirectPage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.redirectPage}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={subCategoryDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                {redirectCategoryData.length === 0 ? <MenuItem disabled>---Please First Select Redirect Page---</MenuItem> : <MenuItem disabled>---Select Category Name---</MenuItem>}
                {redirectCategoryData.map((value, index) => {
                  return <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>
                })}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>


          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Sub Category Name" variant='outlined' fullWidth
              type="text"
              name='subCategoryName'
              value={subCategoryDetail?.subCategoryName}
              onChange={handleInputField}
              error={inputFieldError.subCategoryName ? true : false}
              helperText={inputFieldError.subCategoryName}
              onFocus={() => handleInputFieldError("subCategoryName", null)}
            />
          </Grid>

          {subCategoryDetail?.redirectPage != 'Yatra' ?
            <Grid item lg={6} sm={6} md={12} xs={12} >
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid item xs={2} >
                  <Avatar src={subCategoryImage.file} style={{ width: 40, height: 40 }} />
                </Grid>
                <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  Upload Sub Category Image
                  <input onChange={handleSubCategoryImage} hidden accept="image/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError?.subCategoryImage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.subCategoryImage}</div>}
            </Grid> : " "

          }

          {/* <Grid item lg={12} md={12} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Status</InputLabel>
              <Select
                label="Select Status" variant="outlined" fullWidth
                name='status'
                value={subCategoryDetail?.status}
                onChange={handleInputField}
                error={inputFieldError.status ? true : false}
                onFocus={() => handleInputFieldError("status", null)}
              >
                <MenuItem disabled>---Select Status---</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
            {inputFieldError?.status && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.status}</div>}
          </Grid> */}

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>

  );
};

export default AddSubCategory;